<script lang="ts">
  import type { PersistedAddress } from "../../lib/api/address";
  import SelectorItemLabelComponent from "./SelectorItemLabelComponent.svelte";
  import RadioOn from "../../assets/icons/radio-on.svg";
  import RadioOff from "../../assets/icons/radio-off.svg";
  import { getCopy } from "../../lib/stores/copy";
  import { getFormattedAddress, getDeliveryInstructions } from "../../lib/helpers/address";

  export let address: PersistedAddress;
  export let selected: boolean;
  export let selectAddress: () => void;

  $: copy = $getCopy("address") as Record<string, string>;
  $: deliveryInstructions = getDeliveryInstructions(address);
</script>

<button class="item flex px-4 flex-col items-start gap-4 w-full rounded-lg" class:selected on:click={selectAddress}>
  <div class="flex items-center gap-3 w-full">
    <img src={selected ? RadioOn : RadioOff} alt="Select address" class="w-5 h-5" />
    <SelectorItemLabelComponent label={copy.addressLabel} value={getFormattedAddress(address)} />
  </div>
  {#if address?.address2}
    <div class="ml-8">
      <SelectorItemLabelComponent label={copy.address2Placeholder} value={address.address2} />
    </div>
  {/if}
  {#if deliveryInstructions && deliveryInstructions.length}
    <div class="ml-8">
      <SelectorItemLabelComponent label={copy.deliveryInstructionsLabel} value={deliveryInstructions} />
    </div>
  {/if}
</button>

<style>
  .selected {
    background-color: var(--color-grayscale-10);
  }

  .item {
    padding-top: 1.125rem;
    padding-bottom: 1.125rem;
  }
</style>
